/* unplugin-vue-components disabled */import { render } from "./agent-editor.vue?vue&type=template&id=70548bb3&scoped=true"
import script from "./agent-editor.vue?vue&type=script&lang=js"
export * from "./agent-editor.vue?vue&type=script&lang=js"

import "./agent-editor.vue?vue&type=style&index=0&id=70548bb3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70548bb3"],['__file',"src/pages/settings/admin/test-agents/agent-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70548bb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70548bb3', __exports__)) {
    api.reload('70548bb3', __exports__)
  }
  
  module.hot.accept("./agent-editor.vue?vue&type=template&id=70548bb3&scoped=true", () => {
    api.rerender('70548bb3', render)
  })

}


export default __exports__